import React from 'react';

const SearchForm = () => (
  <>
    <div>
      <form className="searchForm">
        <input type="text" placeholder="Search..." />
      </form>
    </div>
  </>
);

export default SearchForm;
